module.exports = __webpack_public_path__ + "img/imagen7.9d7997ab.png";